import React from 'react';

interface TicketMetricsProps {
    counts: {
        operationStatus_1?: number;
        operationStatus_2?: number;
        operationStatus_3?: number;
        operationStatus_4?: number;
    };
}

const TicketMetrics: React.FC<TicketMetricsProps> = ({ counts }) => {
    const totalTickets =
        (counts.operationStatus_1 || 0) +
        (counts.operationStatus_2 || 0) +
        (counts.operationStatus_3 || 0) +
        (counts.operationStatus_4 || 0);

    const getPercentage = (count: number) =>
        totalTickets > 0 ? (count / totalTickets) * 100 : 0;

    const metrics = [
        {
            title: "New Tickets",
            count: counts.operationStatus_1 || 0,
            icon: "ti ti-ticket",
            color: "#FF6F28",
            borderColor: "border-primary",
            bgColor: "bg-primary-transparent"
        },
        {
            title: "Open Tickets",
            count: counts.operationStatus_2 || 0,
            icon: "ti ti-folder-open",
            color: "#AB47BC",
            borderColor: "border-purple",
            bgColor: "bg-transparent-purple"
        },
        {
            title: "Pending Tickets",
            count: counts.operationStatus_3 || 0,
            icon: "ti ti-progress-alert",
            color: "#0DCAF0",
            borderColor: "border-info",
            bgColor: "bg-info-transparent"
        },
        {
            title: "Closed Tickets",
            count: counts.operationStatus_4 || 0,
            icon: "ti ti-checks",
            color: "#02C95A",
            borderColor: "border-success",
            bgColor: "bg-success-transparent"
        }
    ];

    return (
        <div className="row">
            {metrics.map((metric, index) => (
                <div key={index} className="col-xl-3 col-md-6 d-flex">
                    <div className="card flex-fill">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-6 d-flex">
                                    <div className="flex-fill">
                                        <div className={`border border-dashed ${metric.borderColor} rounded-circle d-inline-flex align-items-center justify-content-center p-1 mb-3`}>
                                            <span className={`avatar avatar-lg avatar-rounded ${metric.bgColor}`}>
                                                <i className={metric.icon} />
                                            </span>
                                        </div>
                                        <p className="fw-medium fs-12 mb-1">{metric.title}</p>
                                        <h4>{metric.count}</h4>
                                    </div>
                                </div>
                                <div className="col-6 text-end d-flex">
                                    <div className="d-flex flex-column justify-content-between align-items-end">
                                        <div className="progress-circle" style={{ width: 70, height: 70, position: "relative" }}>
                                            <svg width="70" height="70" viewBox="0 0 36 36" style={{ transform: "rotate(-90deg)" }}>
                                                <circle cx="18" cy="18" r="16" fill="none" stroke="#e9ecef" strokeWidth="3" />
                                                <circle
                                                    cx="18"
                                                    cy="18"
                                                    r="16"
                                                    fill="none"
                                                    stroke={metric.color}
                                                    strokeWidth="3"
                                                    strokeDasharray={`${getPercentage(metric.count)}, 100`}
                                                />
                                            </svg>
                                            <div style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                fontSize: "12px"
                                            }}>
                                                {Math.round(getPercentage(metric.count))}%
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default TicketMetrics;